export const useImagePlaceholder = (type: 'square' | 'banner') => {
  return `/placeholders/${type}.jpg`
}
